import { FC } from 'react';
import LoadingPanel from 'src/components/LoadingPanel';
import SidePanel from 'src/components/design-system/SidePanel';
import usePeriodView from 'src/hooks/usePeriodView';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import useWindowSize from 'src/hooks/useWindowSize';
import useUpdateGLCodeAttributesApi from 'src/services/useUpdateGLCodeAttributesApi';
import ApprovalWorkflow from './ApprovalWorkflow';
import GLCodeAttributeDropDown from './GLCodeAttributeDropDown';
import ManageGLCodeAttributeAction from './ManageGLCodeAttributesAction';
import ManageGLCodeNote from './ManageGLCodeNote';

interface ManageGLCodeAttributesPanelProps {}
const ManageGLCodeAttributesPanel: FC<ManageGLCodeAttributesPanelProps> = () => {
  const { isGLCodeAtrPanelOpen, handleCancelSidePanel } = usePeriodView();
  const { width } = useWindowSize();
  const { isUpdatingGLCodeAttributes } = useUpdateGLCodeAttributesApi();
  const { isGlCodesBudgetLoading } = useViewCheckbook();

  return (
    <SidePanel
      isOpen={isGLCodeAtrPanelOpen}
      onClose={handleCancelSidePanel}
      position="right"
      width={width < 1200 ? `${width}px` : '1200px'}
      className="manage-glcode-main-panel"
    >
      {(isUpdatingGLCodeAttributes || isGlCodesBudgetLoading) && (
        <LoadingPanel id="ManageGLCodeAttributesPanel" />
      )}
      <ManageGLCodeAttributeAction />
      <GLCodeAttributeDropDown />
      <ManageGLCodeNote />
      <ApprovalWorkflow />
    </SidePanel>
  );
};

export default ManageGLCodeAttributesPanel;
